import File from '../entities/file';

export default function createObjectUrl(file: File) {
    const buf = file.content;

    const arrayBuf = buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength) as ArrayBuffer;

    return window.URL.createObjectURL(new Blob([arrayBuf], { type: file.mime }));
}
